<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Settings History</span><br/>
      <span style="font-style: italic; font-size: 18px">history of settings updates</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
      &nbsp;&nbsp;<b-button v-on:click.prevent="load_data()">Search</b-button>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Filter Results&nbsp;<b-form-input style="width: 260px" v-model="text_filter" placeholder=""/>
    </div>

    <div v-if="!loading">
      <div class="row" style="margin: 30px 10px 30px 10px; font-weight: bold; font-size: 22px;">
        <div class="col" style="border: 1px solid grey;">Total: {{items_full.length}}</div>
        <div class="col" style="border: 1px solid grey;">Filtered: {{items.length}}</div>
      </div>
    </div>

    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="processed_time" slot-scope="row">
          {{row.item.processed_time | formatDateTimeSmall}}
        </template>

        <template slot="updated_by" slot-scope="row">
          <div>{{ format_updated_by(row.item.updated_by) }}</div>
          <div v-if="display_name_differs(row.item.updated_by)" class="updated-by-username">
            {{ row.item.updated_by }}
          </div>
        </template>

        <template slot="diff" slot-scope="row">
          <settings-history-diff-cell :item="row.item" />
        </template>

      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import {get_booking_file_history, get_tenant_config_history, get_users} from '../networking/apis'
import {mapState} from "vuex";
import moment from 'moment'
import {justDate} from "@/helpers/dates";
import settings_history_diff_cell from './settings_history_diff_cell.vue'

export default {
  name: 'tenant_config_history',
  components: {
    'settings-history-diff-cell': settings_history_diff_cell,
  },

  data() {
    return {
      text_filter: '',
      items: [],
      items_full: [],
      summary: [],
      loading: true,
      details_fromDate: justDate(moment().add(-7, 'days')),
      details_toDate: justDate(moment()),
      booking_type: '',
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      fields_all: [],
      fields: [
        { key: 'processed_time', sortable: true, label: 'When', thStyle: { width: "150px" }},
        { key: 'updated_by', sortable: true, label: 'Updated by', thStyle: { width: "180px" }},
        { key: 'diff', sortable: false, label: 'Changes'},
      ],
      users_by_username: {},
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(360, 'days'),
        maxDate: moment().add(0, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },

    }
  },

  async created() {
    this.fields_all = this.fields
    this.check_features()
  },
  methods: {
    async check_features() {
      this.load_data()
    },
    async load_data() {
      this.loading = true
      try {
        // Load users in parallel; failure here is non-fatal because the
        // history table will still render with raw usernames.
        const history_promise = get_tenant_config_history(
          this.user.tenant,
          moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
        )
        const users_promise = get_users(this.user.tenant).catch(() => null)

        const [history_resp, users_resp] = await Promise.all([history_promise, users_promise])
        this.users_by_username = this.build_users_map(users_resp)

        const {value: { data = {} } } = history_resp
        this.summary = data.summary || {}
        moment.tz.setDefault(this.summary.timezone)
        const records = data.records || []
        this.items = records.map(record => this.normalize_history_record(record))
        this.items_full = this.items
        this.filter_results()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    filter_results() {
      this.items = this.items_full
      if (this.text_filter != '') {
        const val = this.text_filter
        this.items = this.items.filter(item =>
          this.contains(JSON.stringify(item.diff), val) ||
          this.contains(item.htmldiff, val) ||
          this.contains(item.updated_by, val) ||
          this.contains(this.format_updated_by(item.updated_by), val) ||
          this.contains(JSON.stringify(item.old), val) ||
          this.contains(JSON.stringify(item.new), val)
        )
      }
    },

    normalize_history_record(record) {
      if (!record) return record
      const normalized = { ...record }
      if (normalized.diff != null && typeof normalized.diff !== 'string') {
        try {
          normalized.diff = JSON.stringify(normalized.diff)
        } catch (e) {
          normalized.diff = String(normalized.diff)
        }
      }
      if (normalized.htmldiff != null && typeof normalized.htmldiff !== 'string') {
        try {
          normalized.htmldiff = JSON.stringify(normalized.htmldiff)
        } catch (e) {
          normalized.htmldiff = String(normalized.htmldiff)
        }
      }
      return normalized
    },
    build_users_map(users_resp) {
      const map = {}
      try {
        const results = users_resp && users_resp.value && users_resp.value.data
          ? (users_resp.value.data.results || [])
          : []
        for (const u of results) {
          if (u && u.username) {
            map[u.username.toLowerCase()] = u
          }
        }
      } catch (e) {
        // best-effort lookup; fall back to username if anything goes wrong
      }
      return map
    },
    format_updated_by(username) {
      if (!username) return ''
      const user = this.users_by_username[String(username).toLowerCase()]
      if (!user) return username
      const first = (user.first_name || '').trim()
      const last = (user.last_name || '').trim()
      const full = [first, last].filter(Boolean).join(' ')
      return full || username
    },
    display_name_differs(username) {
      if (!username) return false
      const formatted = this.format_updated_by(username)
      return formatted && formatted !== username
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },

  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    is_admin() {
      return this.user.role === 'admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    text_filter() {
      this.filter_results()
    }
  }
}
</script>

<style>
.error { background-color: rgba(255,0,0,0.25)}
.success { background-color: hsla(120,100%,75%,0.3)}
.unprocessed { background-color: hsla(200,40%,80%,0.3) }
.cancelled { background-color: hsla(290,60%,70%,0.3) }

.error td { background-color: rgba(255,0,0,0.25)}
.success td {background-color: hsla(120,100%,75%,0.3)}
.unprocessed td { background-color: hsla(200,40%,80%,0.3) }
.cancelled td { background-color: hsla(290,60%,70%,0.3) }


div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

div.wrap {
  border: 1px solid grey;
  flex-wrap: wrap;
  display: flex;
  inline-size: 150px;
  /* overflow-wrap: break-word; */
}

recipients-list {
  white-space: break-spaces !important;
}

.updated-by-username {
  font-size: 11px;
  color: #888;
  margin-top: 2px;
  word-break: break-all;
}
</style>

